import { BottomNavigation, BottomNavigationAction } from '@mui/material';
import React, { useEffect, useState } from 'react';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PlaylistAddCheckOutlinedIcon from '@mui/icons-material/PlaylistAddCheckOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import { useHistory, useLocation } from 'react-router-dom';

export default function BottomMenu () {
    const [value, setValue] = useState(0);
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        if (location.pathname === '/mylist') {
            setValue(1);
        } else if (location.pathname === '/account') {
            setValue(2);
        } else {
            setValue(0);
        }
    }, [location]);

    const handleOnChange = (value) => {
        history.push(['/', '/mylist', '/account'][value]);
    };

    return (
        <BottomNavigation
          showLabels value={value}
          elevation={3}
          onChange={(_, newValue) => handleOnChange(newValue)}>
            <BottomNavigationAction
              label='Home'
              variant={value === 0 ? 'selected' : 'deselected'}
              icon={<HomeOutlinedIcon />} />
            <BottomNavigationAction
              label='My List'
              variant={value === 1 ? 'selected' : 'deselected'}
              icon={<PlaylistAddCheckOutlinedIcon />} />
            <BottomNavigationAction
              label='Account'
              variant={value === 2 ? 'selected' : 'deselected'}
              icon={<AccountCircleOutlinedIcon />} />
        </BottomNavigation>
    );
}
